module.exports = __webpack_public_path__ + "i18n/pt.json";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=i18n/[name].[ext]!./i18n/pt.json
 ** module id = 803
 ** module chunks = 0
 **/